import React from "react";
import Popular from "../../components/popular/Popular";
import Veggie from "../../components/veggie/Veggie";

function Home() {
  return (
    <div>
      <Popular />
      <Veggie />
    </div>
  );
}

export default Home;
